"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../../theme");
const InstructionLabel = styled_components_1.default.label `
  font-size: 0.75rem;
  color: ${theme_1.theme.colors.grey(1)};
  margin-bottom: 4px;
`;
const ErrorLabel = styled_components_1.default.label `
  font-size: 0.75rem;
  color: ${theme_1.theme.colors.red};
  margin-bottom: 4px;
`;
const FileUploadInput = ({ onFileChange, error, maxSizeMB = 30, }) => {
    const handleFileChange = (event) => {
        const maxSize = maxSizeMB * 1024 * 1024 - 500;
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file && file.size > maxSize) {
                onFileChange(null);
                return;
            }
            onFileChange(file);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { id: "fileUpload", type: "file", onChange: handleFileChange }), error ? ((0, jsx_runtime_1.jsx)(ErrorLabel, { htmlFor: "fileUpload", children: error })) : ((0, jsx_runtime_1.jsxs)(InstructionLabel, { htmlFor: "fileUpload", children: ["Upload file (max ", maxSizeMB, "MB)"] }))] }));
};
exports.FileUploadInput = FileUploadInput;
